/* tslint:disable */
/* eslint-disable */
/**
 * Datixo API
 * API endpoints for communication with Datixo.
 *
 * The version of the OpenAPI document: v1.0.0
 * Contact: api@datixo.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GoogleBigQueryRecipeInput
 */
export interface GoogleBigQueryRecipeInput {
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryRecipeInput
     */
    billingProjectId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryRecipeInput
     */
    dataProjectId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryRecipeInput
     */
    datasetId?: string;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryRecipeInput
     */
    location?: string;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryRecipeInput
     */
    maximumBytesBilled?: number;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryRecipeInput
     */
    dailyBytesLimit?: number | null;
    /**
     * 
     * @type {number}
     * @memberof GoogleBigQueryRecipeInput
     */
    monthlyBytesLimit?: number | null;
    /**
     * 
     * @type {string}
     * @memberof GoogleBigQueryRecipeInput
     */
    propertyTimeZone?: string | null;
}

/**
 * Check if a given object implements the GoogleBigQueryRecipeInput interface.
 */
export function instanceOfGoogleBigQueryRecipeInput(value: object): value is GoogleBigQueryRecipeInput {
    return true;
}

export function GoogleBigQueryRecipeInputFromJSON(json: any): GoogleBigQueryRecipeInput {
    return GoogleBigQueryRecipeInputFromJSONTyped(json, false);
}

export function GoogleBigQueryRecipeInputFromJSONTyped(json: any, ignoreDiscriminator: boolean): GoogleBigQueryRecipeInput {
    if (json == null) {
        return json;
    }
    return {
        
        'billingProjectId': json['billingProjectId'] == null ? undefined : json['billingProjectId'],
        'dataProjectId': json['dataProjectId'] == null ? undefined : json['dataProjectId'],
        'datasetId': json['datasetId'] == null ? undefined : json['datasetId'],
        'location': json['location'] == null ? undefined : json['location'],
        'maximumBytesBilled': json['maximumBytesBilled'] == null ? undefined : json['maximumBytesBilled'],
        'dailyBytesLimit': json['dailyBytesLimit'] === undefined ? undefined : json['dailyBytesLimit'] === null ? null : json['dailyBytesLimit'],
        'monthlyBytesLimit': json['monthlyBytesLimit'] === undefined ? undefined : json['monthlyBytesLimit'] === null ? null : json['monthlyBytesLimit'],
        'propertyTimeZone': json['propertyTimeZone'] === undefined ? undefined : json['propertyTimeZone'] === null ? null : json['propertyTimeZone'],
    };
}

export function GoogleBigQueryRecipeInputToJSON(json: any): GoogleBigQueryRecipeInput {
    return GoogleBigQueryRecipeInputToJSONTyped(json, false);
}

export function GoogleBigQueryRecipeInputToJSONTyped(value?: GoogleBigQueryRecipeInput | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'billingProjectId': value['billingProjectId'],
        'dataProjectId': value['dataProjectId'],
        'datasetId': value['datasetId'],
        'location': value['location'],
        'maximumBytesBilled': value['maximumBytesBilled'],
        'dailyBytesLimit': value['dailyBytesLimit'],
        'monthlyBytesLimit': value['monthlyBytesLimit'],
        'propertyTimeZone': value['propertyTimeZone'],
    };
}

